import React, { useCallback, useEffect, useState } from "react";
import { Card, Grid, Box, Typography, IconButton, Checkbox } from "@mui/material";
import whiteBackIcon from "../../../icons/whiteBackIcon.svg";
import { useStyles } from "../styles";
import { AppConfigSettingsViewEnum } from "../applicationsConfigSettings";
import { CustomQuestionTypeEnum } from "@inosio/payments-sdk";
import CustomQuestionFields from "./CustomQuestionFields";
import { InputField } from "../../../components/InputController";
import { applicationStyles } from "../../../resui/applications/components/CustomStyles";
import { useDispatch, useSelector } from "react-redux";
import { getUpdatePropertyGroupConfigs, selectPropertyGroupDetailsState } from "../../../shared/sagas/propertyGroups/propertyGroupsSlice";
import { PmConfigType } from "../pmConfigType";
import { useParams } from "react-router";
import debounce from 'lodash.debounce';

interface PropsType {
  setView: React.Dispatch<React.SetStateAction<AppConfigSettingsViewEnum>>;
}

export default function ApplicationsAdditionalOccupants({ setView }: PropsType) {
  const { uuid: propertyGroupIdParam } = useParams<{ uuid: string }>();
  const dispatch = useDispatch()
  const classes = useStyles();
  const classes1 = applicationStyles();
  const { selectedPropertyGroupAssignedConfigs } = useSelector(selectPropertyGroupDetailsState);
  const [pmConfig, setPmConfig] = useState<PmConfigType>({});
  const [pendingConfig, setPendingConfig] = React.useState<any>(null);

  const getTypography = (text: string, fontWeight: number, fontSize: string, restProps?: object) => (
    <Typography
      sx={{
        fontFamily: 'Work Sans',
        fontWeight: { fontWeight },
        fontSize: { fontSize },
        lineHeight: '22px',
        ...restProps,
      }}
    >
      {text}
    </Typography>
  )

  const onHandleCollectDobChange = (checked: boolean ) => {
    let newPmConfig = {
      ...pmConfig,
      ApplicationsCollectNonAdultOccupantDob : checked
    };

    setPendingConfig({
      ...pendingConfig,
      ApplicationsCollectNonAdultOccupantDob : checked
    })

    setPmConfig(newPmConfig)
  }

  const actuallyDispatchConfigUpdate = () => {
    if (pendingConfig) {
      dispatch(getUpdatePropertyGroupConfigs({ propertyGroupUuid: propertyGroupIdParam, productTypeId: 2, updatedPmConfig: pendingConfig }));
      setPendingConfig(null);
    }
  };

  const delayedConfigUpdate = useCallback(debounce(actuallyDispatchConfigUpdate, 750), [pendingConfig]);

  useEffect(() => {
    delayedConfigUpdate();
    return delayedConfigUpdate.cancel;
  }, [pendingConfig, delayedConfigUpdate]);

  useEffect(() => {
    setPmConfig(selectedPropertyGroupAssignedConfigs);
  }, [selectedPropertyGroupAssignedConfigs]);

  return (
    <Grid item xs={12} sx={{ mt: 3.5 }}>
      <Card sx={{ display: "flex", flexDirection: "column", color: "#000" }}>
        <Box className={classes.headerContainer} sx={{ backgroundColor: '#BE6531' }}>
          <IconButton
            sx={{ marginRight: "10px", marginTop: "-4px" }}
            onClick={() => setView(AppConfigSettingsViewEnum.Dashboard)}
          >
            <img src={whiteBackIcon} alt="" height="14px" />
          </IconButton>
          {getTypography('Non-Adult Occupants', 600, '24px', { color: '#fff' })}
        </Box>

        <Grid container sx={{ p: 2, pt: 2, pb: 1, position: 'relative' }}>

          <Box sx={{ width: '100%', p: 2, pb: 4 }}>
            <Grid container spacing={4}>
              <Grid item xs={12}>
                <Typography sx={{ mb: -2 }} className={classes1.bodyText}>
                  I do not have a non-adult occupant
                  <Checkbox 
                    onChange={() => {}}
                    inputProps={{ 'aria-label': 'controlled' }} 
                    sx={{ ml: 1 }}
                  />
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6} lg={4.5} xl={3.5}>
                <Typography sx={{ mb: 2 }} className={classes1.labelText}>Non-adult occupants</Typography>
                <Typography sx={{ ml: 1, mb: 2 }} className={classes1.bodyText}>
                  This is for occupants under 18 years of age.
                </Typography>
                <InputField
                  name={"FirstName"}
                  label={"First Name"}
                  value={''}
                />
                <InputField
                  name={"MiddleName"}
                  label={"Middle Name"}
                  value={''}
                />
                <InputField
                  name={"LastName"}
                  label={"Last Name"}
                  value={''}
                />
              </Grid>
              <Grid item xs={12} container spacing={4} style={{paddingTop: '0px'}}>
                <Grid item xs={12} sm={6} lg={4.5} xl={3.5}>
                  <InputField
                    name={"Dob"}
                    label={"Date of Birth"}
                    value={''}
                  />
                </Grid>
                <Grid item xs={12} sm={6} lg={4.5} xl={3.5}>
                 <Typography sx={{ mb: -2 }} className={classes1.bodyText} component="div">
                    <Checkbox 
                      checked={pmConfig.ApplicationsCollectNonAdultOccupantDob || false}
                      onChange={(e) => onHandleCollectDobChange(e.target.checked)}
                      inputProps={{ 'aria-label': 'controlled' }} 
                      sx={{ ml: 1 }}
                    />
                    Collect DOB
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Box>

          <CustomQuestionFields CustomQuestionType={CustomQuestionTypeEnum.AdditionalOccupantV1} />
        </Grid>
      </Card>
    </Grid>
  );
}
